// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewOrder_container__ibjpw","content":"ReviewOrder_content__xzjVV","items":"ReviewOrder_items__Act5Q"};